var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-alert 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF06A",
    transform: "translate(3.000000, 3.250000)",
    fill: "#DB544A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C10.6875,17.9765625 12.1992188,17.5664062 13.5351562,16.7695312 L13.5351562,16.7695312 C14.8945312,15.9726562 15.9726562,14.8945312 16.7695312,13.5351562 L16.7695312,13.5351562 C17.5664062,12.1992188 17.9765625,10.6875 18,9 C17.9765625,7.3125 17.5664062,5.80078125 16.7695312,4.46484375 C15.9726562,3.10546875 14.8945312,2.02734375 13.5351562,1.23046875 C12.1992188,0.43359375 10.6875,0.0234375 9,0 C7.3125,0.0234375 5.80078125,0.43359375 4.46484375,1.23046875 C3.10546875,2.02734375 2.02734375,3.10546875 1.23046875,4.46484375 C0.43359375,5.80078125 0.0234375,7.3125 0,9 C0.0234375,10.6875 0.43359375,12.1992188 1.23046875,13.5351562 C2.02734375,14.8945312 3.10546875,15.9726562 4.46484375,16.7695312 C5.80078125,17.5664062 7.3125,17.9765625 9,18 Z M9,4.5 C9.515625,4.546875 9.796875,4.828125 9.84375,5.34375 L9.84375,9.28125 C9.796875,9.796875 9.515625,10.078125 9,10.125 C8.484375,10.078125 8.203125,9.796875 8.15625,9.28125 L8.15625,5.34375 C8.203125,4.828125 8.484375,4.546875 9,4.5 Z M10.125,12.375 C10.125,12.703125 10.0195312,12.9726562 9.80859375,13.1835938 L9.80859375,13.1835938 C9.59765625,13.3945312 9.328125,13.5 9,13.5 C8.671875,13.5 8.40234375,13.3945312 8.19140625,13.1835938 C7.98046875,12.9726562 7.875,12.703125 7.875,12.375 C7.875,12.046875 7.98046875,11.7773438 8.19140625,11.5664062 C8.40234375,11.3554688 8.671875,11.25 9,11.25 C9.328125,11.25 9.59765625,11.3554688 9.80859375,11.5664062 C10.0195312,11.7773438 10.125,12.046875 10.125,12.375 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic-alert.667dadf48538e8303605c4a3b789cfda.svg";
export { ForwardRef as ReactComponent };